export enum ContentTypes {
  TEXT = 'page-content.text',
  IMAGE = 'page-content.image',
  VIDEO = 'page-content.video',
  FILE = 'page-content.file',
  STATIC = 'entity.static-page',
}
